// This file is generated by
// services/coaches/cmd/school_picker/generate_typescript.
// Do not edit directly.

// Map of ISO-3166-2 codes to the names of admin level one entities.
export const ADMIN_LEVEL_ONE_CODES_TO_NAMES: Record<string, string> = {
    "22": "MACHAKOS",
    "30": "NAIROBI",
};

// Map of the administrative levels used in country.
//
// Keys are the ISO-3166-2 codes of the admin-level-one entities.
// Values are the names of the localities within those entities.
export const ADMIN_LEVELS: Record<string, string[]> = {
    "22": [
        "ATHI RIVER",
        "KALAMA",
        "KANGUNDO",
        "KATHIANI",
        "MACHAKOS",
        "MASINGA",
        "MATUNGULU",
        "MWALA",
        "YATTA",
    ],
    "30": [
        "DAGORETTI",
        "EMBAKASI",
        "KAMUKUNJI",
        "KASARANI",
        "KIBRA",
        "LANGATA",
        "MAKADARA",
        "MATHARE",
        "NJIRU",
        "STAREHE",
        "WESTLANDS",
    ],
};
